import { type FC } from 'react'
import { Box, Skeleton, styled } from '@mui/material'
import { ShoppingCartIcon } from '@dhl-ui/icons'

type Props = {
  isLoading?: boolean
  numberOfItems?: number
}

const Circle = styled('span')(({ theme }) => ({
  position: 'absolute',
  top: 0,
  right: 0,
  width: 9,
  height: 9,
  borderRadius: '50%',
  backgroundColor: theme.palette.primary.main,
}))

export const CartIcon: FC<Props> = ({ isLoading, numberOfItems }) => (
  <Box
    sx={{
      pt: 0.5,
      '&:hover': {
        cursor: 'pointer',
      },
    }}
  >
    <Box position="relative">
      {isLoading ? (
        <Skeleton variant="rounded" width={24} height={24} />
      ) : (
        <>
          <ShoppingCartIcon />
          {!!numberOfItems && <Circle />}
        </>
      )}
    </Box>
  </Box>
)
